import mapListSort from '../utils';

const initialState = {
  state: {
    editing: false,
    adding: false,
    erroring: false,
    records: [],
    newEntry: {},
    sortTerm: 'state',
    sortInverse: false,
  },
  carrier: {
    editing: false,
    adding: false,
    erroring: false,
    records: [],
    newEntry: {
      product_ma: false,
      product_mapd: false,
      product_pdp: false,
      product_medigap: false,
      active_date: new Date().toISOString().slice(0, 10),
      active: true,
    },
    page: 'carrierTable',
    saving: false,
    sortTerm: 'plan_year',
    sortInverse: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CARRIER_PERMISSIONS_SAVING':
      return { ...state, carrier: { ...state.carrier, saving: true } };
    case 'CARRIER_PERMISSIONS_DONE_SAVING':
      return { ...state, carrier: { ...state.carrier, saving: false } };
    case 'SET_CARRIER_PERMISSIONS_PAGE':
      return { ...state, carrier: { ...state.carrier, page: action.page } };
    case 'SET_EDIT_PERMISSIONS': {
      const permissions = { ...state[action.level], editing: action.editing, newEntry: action.payload };
      return { ...state, [action.level]: permissions };
    }
    case 'RESET_EDIT_PERMISSIONS_NEW_ENTRY': {
      const permissions = { ...state[action.level], editing: action.editing, newEntry: initialState.carrier.newEntry };
      return { ...state, [action.level]: permissions };
    }
    case 'SET_ADD_PERMISSION': {
      const permissions = { ...state[action.level], adding: action.open };
      return { ...state, [action.level]: permissions };
    }
    case 'LOAD_PERMISSIONS': {
      // Convert states to caps.
      const records = action.records.map((row) => {
        const permission = { ...row };
        if ('state' in permission) {
          permission.state = permission.state.toUpperCase();
        }
        return permission;
      });
      mapListSort(records, state[action.level].sortTerm);
      const permissions = { ...state[action.level], records };
      return { ...state, [action.level]: permissions };
    }
    case 'SET_PERMISSIONS_SORT_TERM': {
      const {
        sortInverse,
        sortTerm,
      } = state[action.level];
      const originalSorts = {
        carrier: 'plan_year',
        state: 'state',
      };
      let newSortTerm = action.sortTerm;
      let newSortInverse = sortInverse;

      // Conditional order important for [ down -> up -> off ] w/ changing sorts
      const setInitialSort = sortTerm === null && newSortTerm !== sortTerm;
      const setNewSort = newSortTerm !== sortTerm;
      const setInverseSort = sortTerm !== null && newSortInverse === false;
      const setDefaultSort = sortTerm !== null && newSortInverse === true;
      if (setInitialSort || setNewSort) {
        newSortInverse = false;
      } else if (setInverseSort) {
        newSortInverse = !newSortInverse;
      } else if (setDefaultSort) {
        newSortTerm = originalSorts[action.level];
        newSortInverse = false;
      }
      const permissions = {
        ...state[action.level],
        sortTerm: newSortTerm,
        sortInverse: newSortInverse,
      };
      const sortedRecords = mapListSort(permissions.records, newSortTerm);
      return {
        ...state,
        [action.level]: {
          ...permissions,
          records: newSortInverse ? sortedRecords.reverse() : sortedRecords,
        },
      };
    }
    case 'EDIT_PERMISSION': {
      const { index: i } = action;
      const permissions = { ...state[action.level] };
      const records = [...permissions.records];

      records[i] = { ...records[i], [action.id]: action.value };
      permissions.records = records;

      return { ...state, [action.level]: permissions };
    }
    case 'EDIT_NEW_PERMISSION': {
      const permissions = { ...state[action.level] };
      permissions.newEntry = { ...permissions.newEntry, [action.id]: action.value };

      return { ...state, [action.level]: permissions };
    }
    case 'SET_PERMISSION_ERROR': {
      const permissions = { ...state[action.level], erroring: action.erroring };
      return { ...state, [action.level]: permissions };
    }
    case 'CLOSE_MODAL':
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
